// Crosses the GraphQL boundary between the requestMagicLink mutation and its
// callers in rmh-patient, so both sides must agree on the exact wire strings.
export enum MagicLinkPurpose {
  SignIn = "SIGN_IN",
  VerifyEmail = "VERIFY_EMAIL",
}
